module.exports = __webpack_public_path__ + "r-v3/img/close_on.45087a6b.svg";